import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import profile from "./profile";
import companies from "./companies";
import company from "./company";
import adminCompanies from "./adminCompanies";
import adminCompany from "./adminCompany";
import config from "./config";
import reports from "./reports";
import report from "./report";
import parser from "./dashboardParser";
import offers from "./dashboardOffers";
import summary from "./dashboardSummary";
import dashboardError from "./dashboardError";

export default combineReducers({
    profile,
    companies,
    company,
    adminCompanies,
    adminCompany,
    config,
    reports,
    report,
    parser,
    offers,
    summary,
    dashboardError,
    routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js